import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import NavBar from "./NavBar";
import SideBar from "./SideBar";
import TimeTracker from "../misc/TimeTracker";
import { Button } from "semantic-ui-react";
import AlertContainer from "react-alert";

class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps.bind(this);
  }

  componentWillMount() {
    let token = localStorage.getItem("flagshipToken");
    if (token !== null) {
      this.props.actions.checkToken(token);
    } else if (
      this.props.router.routes[1].path !== "user/setup/*" &&
      this.props.router.routes[1].path !== "user/reset/*"
    ) {
      Flagship.redirect("/login");
    }

    let resizeWindow = this.props.actions.resizeWindow;

    // Handle window resize events
    window.addEventListener(
      "resize",
      this.debounce(function() {
        resizeWindow(
          Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        );
      })
    );
  }

  componentWillReceiveProps(nextProps) {
    let actions = this.props.actions;

    this.redirectReadOnlyRoute(nextProps);

    if (
      nextProps.notification !== this.props.notification &&
      nextProps.notification.show &&
      nextProps.notification.message
    ) {
      this.msg.show(nextProps.notification.message, {
        type: nextProps.notification.type,
        onClose: actions.clearNotification
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.props.actions.clearDefaultClient();
    }
  }

  redirectReadOnlyRoute(props) {
    if (!props.isLoggedIn || props.accessLevel === 2) {
      return;
    }

    let pathname = props.location.pathname;
    let createRoutes = {
      "/client/create": "/clients",
      "/rfp/create": "/rfps",
      "/io/create": "/ios"
    };
    let redirect = createRoutes[pathname];
    let editRoute = pathname.match(/^\/(client|rfp|io)\/edit\/(.+)$/);

    if (editRoute) {
      redirect = "/" + editRoute[1] + "/view/" + editRoute[2];
    }

    if (redirect) {
      Flagship.redirect(redirect);
    }
  }

  debounce(func) {
    let timer;
    return function(event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, 200, event);
    };
  }

  render() {
    let alertOptions = {
      offset: 10,
      position: "bottom center",
      theme: "dark",
      time: 5000,
      transition: "scale"
    };

    let filterMarket = false;

    if (
      this.props.userRole === "dbs" &&
      this.props.userMarket !== null &&
      this.props.userMarket !== "" &&
      this.props.userMarket !== "Hub"
    ) {
      filterMarket = encodeURI(this.props.userMarket);
    }

    return (
      <div
        id="flagship-app-container"
        className={
          (this.props.sidebarNavActive
            ? "sidebar-nav-open "
            : "sidebar-nav-closed ") +
          (this.props.isLoggedIn ? "user-logged-in" : "user-logged-out")
        }
      >
        <div className="flagship-notifications">
          <AlertContainer
            ref={msg => {
              this.msg = msg;
              return true;
            }}
            {...alertOptions}
          />
        </div>

        {this.props.versionMismatch ? (
          <div className="flagship-version-mismatch">
            <h3>Flagship has been updated.</h3>
            <p>
              For the best experience, click the button below to launch the new
              version in this tab.
            </p>
            <Button
              color="green"
              onClick={() => {
                window.location.reload(true);
              }}
            >
              Launch Now
            </Button>
          </div>
        ) : null}

        {this.props.timeTracking === "1" ? (
          <TimeTracker route={this.props.router.routes[1]} />
        ) : null}

        {this.props.isLoggedIn ? (
          <div>
            <div>
              <NavBar
                openMenu={Flagship.toggleSidebarNav}
                sidebarNavActive={this.props.sidebarNavActive}
              />
            </div>

            <SideBar
              active={this.props.sidebarNavActive}
              userRole={this.props.userRole}
              timeTracking={this.props.timeTracking}
              userId={this.props.userId}
              filterMarket={filterMarket}
            />
          </div>
        ) : null}
        <div id="flagship-main">
          <div id="flagship-main-inner">
            {this.props.children}
            {this.props.isLoggedIn && this.props.accessLevel !== 2 ? (
              <div className="flagship-read-only-notice">
                This legacy system is read-only.
              </div>
            ) : null}
            <small
              className="white-text"
              style={{
                opacity: ".5",
                display: "inline-block",
                margin: "0 0 1em 0"
              }}
            >
              Flagship version {Flagship.config.version}
            </small>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.main.isLoggedIn,
    accessLevel: state.main.accessLevel,
    username: state.main.username,
    userPhoto: state.main.userPhoto,
    sidebarNavActive: state.main.sidebarNavActive,
    errors: state.main.errors,
    notification: state.main.notification,
    userId: state.main.userId,
    userRole: state.main.userRole,
    timeTracking: state.main.timeTracking,
    userMarket: state.main.userMarket,
    userInstance: state.main.userInstance,
    versionMismatch: state.main.versionMismatch
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/ui/App.js